import {
  PROCESS__DATES_MASSIVE_UPLOAD_SET_ALLOW_UPLOAD,
  PROCESS__DATES_MASSIVE_UPLOAD_CLEAR_ALLOW_UPLOAD,
  PROCESS__DATES_MASSIVE_UPLOAD_REQUEST_VERIFY,
  PROCESS__DATES_MASSIVE_UPLOAD_SET_VERIFY,
  PROCESS__DATES_MASSIVE_UPLOAD_CLEAR_VERIFY,
  PROCESS__DATES_MASSIVE_UPLOAD_REQUEST_UPLOAD,
  PROCESS__DATES_MASSIVE_UPLOAD_SET_UPLOAD,
  PROCESS__DATES_MASSIVE_UPLOAD_CLEAR_UPLOAD,
} from '../actions';

function processDatesMassiveUploadReducer(state = {}, action) {
  const { type } = action;

  switch (type) {
    case PROCESS__DATES_MASSIVE_UPLOAD_SET_ALLOW_UPLOAD:
      return {
        ...state,
        isLoading: false,
        allowUpload: action.payload,
      };

    case PROCESS__DATES_MASSIVE_UPLOAD_CLEAR_ALLOW_UPLOAD:
      return {
        ...state,
        isLoading: false,
        allowUpload: null,
      };

    case PROCESS__DATES_MASSIVE_UPLOAD_REQUEST_VERIFY:
      return {
        ...state,
        isLoading: true,
        verify: null,
      };

    case PROCESS__DATES_MASSIVE_UPLOAD_SET_VERIFY:
      return {
        ...state,
        isLoading: false,
        verify: action.payload,
      };

    case PROCESS__DATES_MASSIVE_UPLOAD_CLEAR_VERIFY:
      return {
        ...state,
        isLoading: false,
        verify: null,
      };

    case PROCESS__DATES_MASSIVE_UPLOAD_REQUEST_UPLOAD:
      return {
        ...state,
        isLoading: true,
        upload: null,
      };

    case PROCESS__DATES_MASSIVE_UPLOAD_SET_UPLOAD:
      return {
        ...state,
        isLoading: false,
        upload: action.payload,
      };

    case PROCESS__DATES_MASSIVE_UPLOAD_CLEAR_UPLOAD:
      return {
        ...state,
        isLoading: false,
        upload: null,
      };

    default:
      return state;
  }
}

export default processDatesMassiveUploadReducer;
